import { render } from "./CreateSearchBtn.vue?vue&type=template&id=72447b60&ts=true"
import script from "./CreateSearchBtn.vue?vue&type=script&lang=ts"
export * from "./CreateSearchBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
